import { GoalType } from '@griply/types';
import { useGoalById } from 'features/goals';
import React from 'react';
import { useParams } from 'react-router';

import { CompletionBanner } from './components/completion-banner';
import { GoalDetailHeader } from './components/goal-detail-header';
import { ProgressSection } from './components/progress-section';
import { SubItemsSection } from './components/sub-items-section';
import * as Styled from './summary.style';
import { SummaryRoadmap } from './summary-roadmap';

export const Summary: React.FC = () => {
  const { id } = useParams();
  const goal = useGoalById(id);

  if (!goal) {
    return null;
  }

  const isProject = goal.type === GoalType.Project;
  const showRoadmap = !isProject && (goal.showRoadmap ?? true);

  return (
    <>
      {!isProject && <CompletionBanner goal={goal} />}

      <Styled.TopRow>
        <Styled.Column>
          <GoalDetailHeader />
        </Styled.Column>

        {!isProject && (
          <Styled.Column>
            <ProgressSection />
          </Styled.Column>
        )}
      </Styled.TopRow>

      {showRoadmap && <SummaryRoadmap />}
      <SubItemsSection grow hasLink />
    </>
  );
};
